module.exports = __webpack_public_path__ + "static/media/videoEmpresa.c2d7848e.mp4";